import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	showFullHierarchy: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.filter-bar.options.show-full-hierarchy.show-full-hierarchy',
		defaultMessage: 'Show full hierarchy',
		description: 'This label for the show full hierarchy option',
	},
});
